import { TFunction } from "i18next";

export const getEducationTrainingOptions = (t: TFunction) => [
  { value: "trained", label: t("employee.trained") },
  { value: "isNotTrained", label: t("employee.isNotTrained") },
  { value: "processLearning", label: t("employee.processLearning") },
];

export const getEducationCertificateOptions = (t: TFunction) => [
  { value: "passedCertification", label: t("employee.passedCertification") },
  { value: "notCertified", label: t("employee.notCertified") },
  { value: "notProvided", label: t("employee.notProvided") },
  { value: "expiredCertification", label: t("employee.expiredCertification") },
];

export const getEmailVerificationOptions = (t: TFunction) => [
  { value: true, label: t("employee.verifiedMail") },
  { value: false, label: t("employee.unverifiedMail") },
];
